export default "__VITE_ASSET__D77gcXGR__"